import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { Steps, Button } from "antd";
import { message } from "antd";
import {
  UserOutlined,
  SolutionOutlined,
  FormOutlined,
  QuestionOutlined,
} from "@ant-design/icons";
import axiosInstance from "../../api/utils/axiosInstance";
import { DOCUMENT_PURGE } from "../../constants/constants";
import DocumentOptions from "../../components/UI/DocumentOptions/DocumentOptions";
import IzlazniDokument from "../../components/IzlazniDokument/IzlazniDokument";
import RichTextEditorComponent from "../../components/RichTextEditorComponent/RichTextEditorComponent";
import {
  formSubmitSuccess,
  formSubmitError,
} from "../../store/actions/forms/formActions";

const { Step } = Steps;

class KreiranjeRjesenja extends Component {
  state = {
    optionPicked: "",
    isLoading: false,
    acts: [],
    steps: {
      current: 0,
    },
    stepTitles: [
      {
        title: "Kreiraj/Učitaj izlazni dokument/akt",
        content: "First-content",
        icon: <UserOutlined />,
      },
      {
        title: "",
        content: "Second-content",
        icon: <QuestionOutlined />,
      },
    ],
    actSelected: null,
    selectedFiles: [],
    documentSaved: false,
    statuses: [
      { id: 3, value: "DOPUNA" },
      { id: 4, value: "ODBACENO" },
      { id: 5, value: "OBUSTAVLJENO" },
      { id: 6, value: "ODBIJENO" },
      { id: 7, value: "U OBRADI" },
      { id: 8, value: "PRIHVACENO" },
    ],
    selectedStatus: "",
    unosEnabled: true,
  };

  componentDidMount = () => {
    const { requestUuid, zahtjevAtrId, formId } = this.props;

    if (!requestUuid || !formId || !zahtjevAtrId) {
      this.props.history.push("/odobrenje-zahtjeva");
    }

    // TODO: ne redirecta dobro na page not found
    if (this.props.match.params.requestUuid != requestUuid) {
      this.props.documentPurge();
      toast.info("Nešto je pošlo po krivu. Molimo pokušajte ponovno!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      // this.props.history.push("/page-not-found");
      this.props.history.push("/odobrenje-zahtjeva");
    }
  };

  optionsHandler = (e) => {
    const eventId = e.target.value;
    eventId == 1 &&
      this.setState((prevState) => ({
        optionPicked: 1,
        stepTitles: [
          {
            title: "Kreiraj/Učitaj izlazni dokument/akt",
            content: "First-content",
            icon: <UserOutlined />,
          },
          {
            title: "Text editor",
            content: "Second-content",
            icon: <SolutionOutlined />,
          },
        ],
      }));
    eventId == 2 &&
      this.setState((prevState) => ({
        optionPicked: 2,
        stepTitles: [
          {
            title: "Kreiraj/Učitaj izlazni dokument/akt",
            content: "First-content",
            icon: <UserOutlined />,
          },
          {
            title: "Učitaj dokument",
            content: "Second-content",
            icon: <SolutionOutlined />,
          },
          {
            title: "Odabir statusa",
            content: "Third-content",
            icon: <FormOutlined />,
          },
        ],
      }));
  };

  uploadHandler = (file, id) => {
    if (file.file.status === "removed") {
      this.setState((prevState) => ({
        selectedFiles: [
          ...prevState.selectedFiles.filter((element) => element.id != id),
        ],
      }));
      return;
    }

    let selectedFiles = {
      id: id,
      file: null,
      name: file.file.name,
      uid: file.file.uid,
    };
    selectedFiles.file = file.file;

    const isFileLt10MB = file.file.size / 1024 / 1024 < 10;
    if (file.file.size && !isFileLt10MB) {
      message.error("Nije dopušteno učitavanje datoteka većih od 10MB.");
      return;
    }

    let setSelectedFiles = [...this.state.selectedFiles];
    setSelectedFiles = [];
    setSelectedFiles.push(selectedFiles);
    this.setState({
      selectedFiles: setSelectedFiles,
    });
  };

  handleRadioButton = (e) => {
    const { id } = e.target;
    this.setState({
      selectedStatus: id,
    });
  };

  submitUploadedDocument = (e) => {
    this.setState({ isLoading: true }, () => {
      let formData = new FormData();
      for (let i = 0; i < this.state.selectedFiles.length; i++) {
        formData.append("files", this.state.selectedFiles[i].file);
      }

      axiosInstance
        .patch(
          `/requests/set-status-upload?noviStatusId=${this.state.selectedStatus}&vrstaDokumentaId=2&zahtjevAtrId=${this.props.zahtjevAtrId}`
        )
        .then((res) => {
          return axiosInstance.post(
            `/upload/attachments?zahtjevId=${this.props.requestUuid}&zahtjevAtrId=${res.data.zahtjevAtrId}&vrstaDokumentaId=2`,
            formData
          );
        })
        .then((res) => {
          this.props.history.push("/odobrenje-zahtjeva");
          this.props.formSubmitSuccess(
            false,
            "Dokument je uspješno pohranjen!"
          );
        })
        .catch(() => {
          this.props.history.push("/odobrenje-zahtjeva");
          this.props.formSubmitError(true, "Nešto je pošlo po krivu!");
        })
        .finally(() => {});
    });
  };

  next = () => {
    this.setState((prevState) => ({
      steps: {
        ...prevState.steps,
        current: prevState.steps.current + 1,
      },
    }));
  };

  prev = () => {
    this.setState(
      (prevState) => ({
        steps: {
          ...prevState.steps,
          current: prevState.steps.current - 1,
        },
      }),
      () => {
        const { current } = this.state.steps;
        if (current === 0) {
          this.setState((prevState) => ({
            selectedFiles: [],
          }));
        }
        if (current === 1) {
          this.setState((prevState) => ({
            selectedStatus: "",
          }));
        }
      }
    );
  };

  render() {
    const { stepTitles } = this.state;
    const { current } = this.state.steps;

    const izlazniDokumentProps = {
      optionPicked: this.state.optionPicked,
      documentSaved: this.state.documentSaved,
      uploadHandler: this.uploadHandler,
      selectedFiles: this.state.selectedFiles,
      statuses: this.state.statuses,
      selectedStatus: this.state.selectedStatus,
      submitUploadedDocument: this.submitUploadedDocument,
      saveDocument: this.saveDocument,
      handleRadioButton: this.handleRadioButton,
      current: this.state.steps.current,
    };

    return (
      <div>
        <Row className="row justify-content-center">
          <Col xl={8} lg={10} md={12} className="align-self-center">
            <Steps current={current}>
              {stepTitles.map((item) => (
                <Step icon={item.icon} key={item.title} title={item.title} />
              ))}
            </Steps>
            {current == 0 && (
              <Row>
                <Col className="steps-content">
                  <DocumentOptions
                    optionsHandler={this.optionsHandler}
                    optionPicked={this.state.optionPicked}
                  />
                </Col>
              </Row>
            )}
            {(current == 1 || current == 2) && this.state.optionPicked == 2 && (
              <Row>
                <Col className="steps-content">
                  <IzlazniDokument {...izlazniDokumentProps} />
                </Col>
              </Row>
            )}

            {current == 1 && this.state.optionPicked == 1 && (
              <div style={{ marginTop: "16px" }}>
                <RichTextEditorComponent />
              </div>
            )}
            <div className="steps-action invert">
              {current == 0 && (
                <Button
                  disabled={!this.state.optionPicked}
                  type="primary"
                  onClick={this.next}
                  role="button"
                >
                  Nastavi
                </Button>
              )}
              {current == 1 && this.state.optionPicked == 2 && (
                <Button
                  type="primary"
                  disabled={this.state.selectedFiles.length < 1}
                  onClick={this.next}
                >
                  Nastavi
                </Button>
              )}
              {current == 2 && this.state.optionPicked == 2 && (
                <Button
                  type="primary"
                  disabled={!this.state.selectedStatus}
                  onClick={this.submitUploadedDocument}
                  loading={this.state.isLoading}
                >
                  Spremi izlazni dokument
                </Button>
              )}
              {current > 0 && (
                <Button
                  style={{ margin: 8 }}
                  onClick={() => this.prev()}
                  className="ant-btn-back"
                >
                  Povratak
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formId: state.formData.formId,
    requestUuid: state.formData.documentUUID,
    zahtjevAtrId: state.formData.zahtjevAtrId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    documentPurge: () => dispatch({ type: DOCUMENT_PURGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(KreiranjeRjesenja);
